import { FC } from 'react'
import Dropdown from '@/components/dropdown'

export interface HeaderProps {
  title: string
  className?: string
  showCloseButton?: boolean
  showDivider?: boolean
}

export const _Header: FC<HeaderProps> = (props) => {
  return <Dropdown.Header {...props} />
}
